import { Typography } from '@mui/material';
import { HorizontalLine } from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle, InfoRow, InfoLabel } from '../ThreatTable/ThreatExpandedRow.style';

interface ExpandedTakedownInfoProps {
  takedown: any;
}

const ExpandedTakedownInfo = ({ takedown }: ExpandedTakedownInfoProps) => {
  const rejection =
    takedown?.rejection_reason && takedown?.rejection_description
      ? `${takedown.rejection_reason}: ${takedown.rejection_description}`
      : takedown?.rejection_reason || takedown?.rejection_description;

  return (
    <SectionColumn>
      <SectionTitle>Takedown Info</SectionTitle>
      <HorizontalLine sx={{ mb: 1 }} />

      {takedown?.description && (
        <InfoRow>
          <InfoLabel>Description:</InfoLabel>
          <Typography variant="body2">{takedown.description}</Typography>
        </InfoRow>
      )}

      {takedown?.cancellation_reason && (
        <InfoRow>
          <InfoLabel>Cancellation:</InfoLabel>
          <Typography variant="body2">
            {takedown.custom_cancellation_reason
              ? `${takedown.cancellation_reason}: ${takedown.custom_cancellation_reason}`
              : takedown.cancellation_reason}
          </Typography>
        </InfoRow>
      )}

      {rejection && (
        <InfoRow>
          <InfoLabel>Rejection:</InfoLabel>
          <Typography variant="body2">{rejection}</Typography>
        </InfoRow>
      )}
    </SectionColumn>
  );
};

export default ExpandedTakedownInfo;
